import * as alteredstates from '@/api/alteredstates'

export const initStore = ({ commit }) => {
  alteredstates.getAllTunings(tunings => {
    commit('initStore', tunings)
  })
}

export const changeSelectedKey = ({ commit }, key) => {
  commit('changeSelectedKey', key)
}

export const changeTuning = ({ commit }, tuning) => {
  commit('changeTuning', tuning)
}



// WEBPACK FOOTER //
// ./src/store/actions.js